$giper_baza_rich_edit $mol_view
	pawn? $giper_baza_rich
	attr *
		^
		giper_baza_rich_edit_enabled <= enabled true
	hint \
	auto /
		<= selection_load null
		<= selection_sync null
	plugins /
		<= Hotkey $mol_hotkey2 action *
			alt_S? <=> inline_toggle*strong? null
			alt_E? <=> inline_toggle*em? null
			alt_I? <=> inline_toggle*ins? null
			alt_R? <=> inline_toggle*del? null
			alt_C? <=> inline_toggle*code? null
			-
			alt_T? <=> block_wrap*section? null
			alt_Q? <=> block_wrap*blockquote? null
			alt_U? <=> block_wrap*ul? null
			alt_O? <=> block_wrap*ol? null
			alt_P? <=> block_wrap*pre? null
			-
			tab? <=> block_rewrap? null
			shift_tab? <=> block_unwrap? null
	sub /
		<= Tools $mol_float sub /
			<= Inline_format_menu $mol_pick
				hint @ \Inline Formating
				trigger_content /
					<= Inline_format_menu_icon $mol_icon_marker
				bubble_content /
					<= Strong_button $mol_button_minor
						title @ \Strong
						hint \Alt+S
						enabled? <=> selected? false
						click? <=> inline_toggle*strong?
					<= Em_button $mol_button_minor
						title @ \Emphasis
						hint \Alt+E
						enabled? <=> selected? false
						click? <=> inline_toggle*em?
					<= Ins_button $mol_button_minor
						title @ \Insertion
						hint \Alt+I
						enabled? <=> selected? false
						click? <=> inline_toggle*ins?
					<= Del_button $mol_button_minor
						title @ \Deletion
						hint \Alt+R
						enabled? <=> selected? false
						click? <=> inline_toggle*del?
					<= Code_button $mol_button_minor
						title @ \Code
						hint \Alt+C
						enabled? <=> selected? false
						click? <=> inline_toggle*code?
			<= Section_button $mol_button_minor
				hint @ \Titled Section (Alt+T)
				enabled? <=> selected? false
				click? <=> block_wrap*section?
				sub /
					<= Section_icon $mol_icon_format_size
			<= List_bullet_button $mol_button_minor
				hint @ \Unordered List (Alt+U)
				enabled? <=> selected? false
				click? <=> block_wrap*ul?
				sub /
					<= List_bullet_icon $mol_icon_order_bool_ascending
			<= List_number_button $mol_button_minor
				hint @ \Ordered List (Alt+O)
				enabled? <=> selected? false
				click? <=> block_wrap*ol?
				sub /
					<= List_number_icon $mol_icon_order_numeric_ascending
			<= Quote_button $mol_button_minor
				hint @ \Quotation (Alt+Q)
				enabled? <=> selected? false
				click? <=> block_wrap*blockquote?
				sub /
					<= Quote_icon $mol_icon_comment_quote_outline
			<= Preformat_button $mol_button_minor
				hint @ \Preformatted Code (Alt+P)
				enabled? <=> selected? false
				click? <=> block_wrap*pre?
				sub /
					<= Preformat_icon $mol_icon_xml
			<= Unwrap_button $mol_button_minor
				hint @ \Unwrap Block (Shift+Tab)
				enabled? <=> selected? false
				click? <=> block_unwrap?
				sub /
					<= Decrease_icon $mol_icon_arrow_collapse_left
		<= Content $mol_view
			attr *
				contenteditable <= editable? \true
			event *
				input? <=> save? null
				paste? <=> paste? null
				pointermove? <=> hover? null
			sub <= content /
